import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { MrpJobOrderBinLinkContainerModel } from '../../../../../../models/aggregates/mrp-prodsys/mrp-job-order-bin-link-container.model';

@Injectable({ providedIn: 'root' })
export class MrpJoboRderBinLinkService extends BaseApiTemplateService<MrpJobOrderBinLinkContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MRP_PREFIX + "bl_mrp_job_order_bin_links/" + Core2Config.BACKOFFICE_EP_SUFFIX;

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MRP_PREFIX +
      "bl_mrp_job_order_bin_links/" + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MRP_PREFIX +
      "bl_mrp_job_order_bin_links/" + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = http;
  }
}
